import React from "react";
import {
    Box,
    Chip,
    Tooltip,
    Typography,
    useTheme,
} from "@mui/material";
import { Inventory } from "@mui/icons-material";
import CollapsibleTable from "shared-component/collapsible-table";
import { headerDataResponse } from "assets/DataFile/headerResponse";
import { sortJobAuditList } from "utility/helper";

export const getStatusElement = (status: string) => {
    switch (status?.toLowerCase()) {
        case "success":
            return (
                <Tooltip title={"View the job details"}>
                    <Chip
                        label="Success"
                        variant="outlined"
                        color="success"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                </Tooltip>
            )
        case "in progress":
            return (
                <Tooltip title={"Job will be processed shortly."}>
                    <Chip
                        label="In Progress"
                        variant="outlined"
                        color="warning"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                </Tooltip>
            )
        case "submitted":
            return (
                <Tooltip title={"Job will be processed shortly."}>
                    <Chip
                        label="Submitted"
                        variant="outlined"
                        color="warning"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                </Tooltip>
            )
        case "error":
            return (
                <Tooltip title={"Error with current job Please Re-trigger"}>
                    <Chip
                        label="Error"
                        variant="outlined"
                        color="error"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                </Tooltip>
            )
        default:
            return null;
    }
};

export const JobAuditTable = (props: any) => {
    const theme = useTheme();

    return (
        <>

            <CollapsibleTable headData={props?.headData} auditList={sortJobAuditList(headerDataResponse?.jobs)} handleHeaderDataClick={props?.handleHeaderDataClick} handleRawDataClick={props?.handleRawDataClick} />
            {props?.auditList?.length === 0 && <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexDirection={"column"}
                height={200}
                width={200}
                marginLeft={'auto'}
                marginRight={'auto'}
            >
                <Inventory fontSize="large" color="disabled" />
                <Typography
                    variant="caption"
                    fontWeight={"bold"}
                    color={theme.palette.text.disabled}
                >
                    No Jobs
                </Typography>
            </Box>}
        </>
    );
};